// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	api_endpoint: 'https://test.arctic.klean.it',
	auth_token: 'UFk2T2VLSTFqNzhlcE8zaFBhMHVTRWpSQXVxYTJuWUZlRVFWYmYybTpmQVM5VHF6djF5OVNKTzJPT1B3Y2JWN201N2pybWhTSXRMaE4zZmt5'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
